import {StepCard, StepCardProps} from '@features/assignment/components/step-card'
import {FC, useEffect, useRef} from 'react'
import {ScrollArea, Scrollbar} from '@components/ui/scroll-area'

type Steps = Array<StepCardProps & {isCurrent: boolean}>
export const Steps: FC<{steps: Steps}> = ({steps}) => {
    const currentStepRef = useRef<HTMLDivElement | null>(null)

    useEffect(() => {
        currentStepRef.current?.scrollIntoView({block: 'nearest', inline: 'start'})
    }, [])

    return (
        <div className="w-full rounded-xl border border-neutral-300 shadow-lg">
            <ScrollArea
                scrollbar={
                    <Scrollbar
                        orientation="horizontal"
                        className="m-0 -mb-2 data-[orientation=horizontal]:h-0 md:data-[orientation=horizontal]:h-1.5"
                    />
                }
            >
                <div
                    className="grid gap-4 px-4"
                    style={{gridTemplateColumns: `repeat(${steps.length}, minmax(max-content, 1fr))`}}
                >
                    {steps.map(step => (
                        <StepCard {...step} ref={step.isCurrent ? currentStepRef : null} key={step.number} />
                    ))}
                </div>
            </ScrollArea>
        </div>
    )
}
